import type { ReactNode } from 'react'
import React from 'react'
import { BaseIcon } from '@fs/zion-icon/dist/es/BaseIcon'

function SearchPartnerIcon({ children }: { children: ReactNode }): JSX.Element {
  return (
    <BaseIcon role="img" aria-hidden="true" size="sm">
      {children}
    </BaseIcon>
  )
}

export function AncestryIcon(): JSX.Element {
  return (
    <SearchPartnerIcon>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 800 800" xmlSpace="preserve">
        <style type="text/css">{`.ancestrySvg{fill-rule:evenodd;clip-rule:evenodd;fill:#9CBE30;}`}</style>
        <g>
          <path
            className="ancestrySvg"
            d="M454.52,252.41c-47.55-51.63-95.1-43.47-103.25-42.12c4.08,1.36,8.15,91.03,58.42,138.58
          c33.96,31.24,103.25,20.38,103.25,20.38S500.72,302.68,454.52,252.41 M511.59,427.67c-14.95,0-76.08,5.44-116.84,55.7
          c-42.12,52.99-40.76,95.11-50.27,104.61c8.15,2.72,93.75,10.87,130.43-44.83C510.23,491.52,511.59,435.82,511.59,427.67
          M139.33,390.98c9.51,1.36,42.12,43.48,100.54,48.91c63.85,6.8,85.59-25.81,86.95-25.81c0-4.08-51.63-59.78-108.69-59.78
          C178.72,355.67,139.33,390.99,139.33,390.98 M371.65,419.52c-1.36,1.36-54.34,72.01-179.33,52.99
          C91.77,456.2,55.09,400.5,48.3,399.14c8.15-10.87,84.24-72.01,172.54-70.65c86.96,2.72,150.81,51.63,150.81,51.63h55.7
          c-44.83-13.59-99.17-38.04-123.63-92.39c-21.74-50.27-17.66-80.16-27.17-122.27c0,0,100.54-8.15,177.98,42.11
          c70.65,46.19,110.05,168.47,111.41,172.54h43.47l-9.51-217.38l54.34,1.36c-9.51,57.06,2.72,464.65,0,464.65
          c-5.43,1.35-51.63,4.07-55.7-6.8c0,0,10.87-199.71,12.23-203.79h-42.12c0,2.72-4.08,115.48-89.66,175.26
          c-85.6,59.78-209.23,42.11-209.23,42.11c14.95-23.1,0-47.55,43.47-114.12c50.27-76.08,116.84-103.26,115.49-103.26
          C424.64,419.52,373.01,419.52,371.65,419.52"
          />
        </g>
      </svg>
    </SearchPartnerIcon>
  )
}

export function FamilySearchIcon(): JSX.Element {
  return (
    <SearchPartnerIcon>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M11.61 19.8403C12.7527 19.1106 13.5695 17.9678 13.89 16.6503H13.28C13.1078 17.118 12.8322 17.5408 12.4738 17.8871C12.1153 18.2334 11.6833 18.4943 11.21 18.6503C10.8276 17.2925 10.7414 15.8685 10.957 14.4745C11.1727 13.0805 11.6852 11.7491 12.46 10.5703H11.21C10.2108 11.9704 9.55951 13.5884 9.31 15.2903C8.57722 14.8686 8.02012 14.198 7.74 13.4003H7.09C7.40916 14.6566 8.15951 15.7609 9.21 16.5203V16.8403C9.19852 19.4779 10.1598 22.0271 11.91 24.0003H14.91C13.464 22.9365 12.331 21.503 11.63 19.8503"
          fill="#9B947B"
        />
        <path d="M15 11H20V6H15V11ZM19 10H16V7H19V10Z" fill="#BBB7B1" />
        <path d="M12 17H17V12H12V17ZM16 16H13V13H16V16Z" fill="#BBB7B1" />
        <path d="M10 11H14V7H10V11ZM13 10H11V8H13V10Z" fill="#9B947B" />
        <path d="M6 8H9V5H6V8ZM8.18 7.18H6.82V5.82H8.18V7.18Z" fill="#BBB7B1" />
        <path d="M10 6H14V2H10V6ZM13.14 5.14H10.86V2.86H13.14V5.14Z" fill="#86BA40" />
        <path d="M4 14H9V9H4V14ZM8 13H5V10H8V13Z" fill="#86BA40" />
        <path d="M18 15H21V12H18V15ZM20.1 14.1H18.9V12.9H20.1V14.1Z" fill="#86BA40" />
      </svg>
    </SearchPartnerIcon>
  )
}

export function FilaeIcon(): JSX.Element {
  return (
    <SearchPartnerIcon>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 800 800" xmlSpace="preserve">
        <style type="text/css">{`.filaeSvg{fill:#EB5659;}`}</style>
        <path
          className="filaeSvg"
          d="M629.28,181.01v343.16c0,22.1-17.91,40.01-40.01,40.01H480.96c-23.17,0-12.1,22.13-3.81,33.19
	s30.43,60.85-13.83,91.28c-44.25,30.43-94.04-2.77-105.1-16.6c-11.06-13.83-8.3-60.85,0-69.15c8.3-8.3,13.02-22.13,13.02-38.72
	l1.86-142.29h73.99c0,0,11.38-41.74,13.28-51.23c1.9-9.49-1.9-18.97-11.46-18.97H373.1v-53.12h132.81c0,0,13.28-47.43,15.18-53.12
	c1.9-5.69,1.9-18.7-14.18-18.7c-16.08,0-158.46,0-173.97,0c-15.5,0-30.03,20.6-30.03,32.86c0,0,0,283.71,0,291.3
	c0,4.91,1.59,10.17,4,13.28h-60.8c-22.1,0-40.01-17.91-40.01-40.01V414.44c0-13.44-16.17-19.83-28.83-6.96
	c-12.66,12.87-67.34,22.13-87.34-3.72c-28.93-35.1-24.89-74.68,0-99.57c30.43-30.43,77.45-16.6,91.28-2.77
	c8.3,8.3,24.89,14.38,24.89-6.64V181.01c0-22.1,17.91-40.01,40.01-40.01h343.16C611.37,141,629.28,158.91,629.28,181.01z"
        />
      </svg>
    </SearchPartnerIcon>
  )
}

export function FindmypastIcon(): JSX.Element {
  return (
    <SearchPartnerIcon>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 800 800" xmlSpace="preserve">
        <style type="text/css">{`.findmypastSvg{fill:#E77775;}`}</style>
        <g>
          <g id="_x34_nVHiZ_00000147934669484783024800000003194287164454235265_">
            <g>
              <path
                className="findmypastSvg"
                d="M363.43,167c12.13,6.08,24.37,11.98,36.32,18.4c2.62,1.41,5.13,4.38,6.15,7.19
				c13.25,36.36,10.64,74.43,10.93,112.02c0.28,36.29-1.94,72.59-2.07,108.89c-0.09,25.53,2.08,51.07,2.01,76.6
				c-0.02,8.58-3.84,17.15-6.35,27.47c-21.8-10.31-39.69-19.92-49.1-39.99c-1.05-2.25-1.97-4.82-1.99-7.25
				c-0.22-29.65-0.58-59.31-0.27-88.95c0.41-38.43,1.4-76.85,2.11-115.28c0.03-1.67-0.22-3.35-2.98-5.75
				c-4.94,12.42-10.88,24.55-14.63,37.32c-15.18,51.73-29.83,103.62-44.35,155.53c-3.77,13.47-11.11,18.36-24.05,13.9
				c-8.03-2.77-16.03-5.77-23.66-9.46c-6.58-3.18-10.42-8.1-10.69-16.53c-1.83-59.21-4.18-118.4-6.5-177.59
				c-0.2-5.1-1.37-10.16-4.73-15.66c-3.48,15.39-7.85,30.64-10.29,46.2c-10.7,68.36-20.88,136.81-31.13,205.24
				c-0.76,5.1,0.66,10.76-0.99,15.43c-3.39,9.56-8.19,18.63-12.2,27.42c-11.95-5.08-22.12-8.3-31.02-13.62
				c-5.08-3.04-10.04-8.96-11.63-14.56c-2.91-10.2-4.43-21.12-4.5-31.75c-0.4-59.68-0.43-119.36-0.09-179.03
				c0.18-31.85,1.32-63.7,2.07-95.55c0.26-11.05,9.39-23.41,18.29-24.92c10.48-1.78,19.35,4.18,24.01,16.83
				c2.51,6.82,4.16,13.95,7.03,23.81c7.18-22.53,21.55-35.54,38.97-45.97c6.47-3.87,12.01-4.35,18.45-0.04
				c8.61,5.77,18.58,9.81,26.3,16.51c11.62,10.08,16.9,24.4,20.16,39.16c2.15,9.75,3.2,19.73,5,29.56
				c1.26,6.88,2.95,13.68,4.5,20.71c6.82-17.61,12.66-35.02,20.23-51.65c10.95-24.08,24.15-46.83,47.21-61.86
				c0.72-0.47,0.85-1.83,1.26-2.77C361.94,167,362.68,167,363.43,167z"
              />
              <path
                className="findmypastSvg"
                d="M679.39,251.55c-2.12,18.32-3.29,36.8-6.53,54.92c-13.97,78.28-28.26,156.5-43.03,234.63
				c-6.45,34.14-14.03,68.08-21.66,101.98c-5.65,25.08-22.08,34.46-44.8,26.58c-7.62-45.6,10.35-87.89,17.2-131.6
				c2.61-16.65,6.33-33.12,9.37-49.7c0.28-1.55-0.7-3.33-1.06-4.87c-8.67,5.11-16.78,10.03-25.07,14.65
				c-1.7,0.94-4.28,1.49-6.05,0.93c-30.28-9.67-52.41-27.62-62.06-59.32c-12.63-41.49-15.11-84.38-18.42-127.13
				c-1.84-23.84-2.16-47.83-2.17-71.75c0-8.87,2.84-17.75,4.35-26.48c18.91,0.87,28.52,10.05,30.69,25.74
				c3.59,25.98,5.98,52.12,8.87,78.2c3.75,33.84,6.34,67.86,11.77,101.42c2.27,14.01,10.55,27.05,16.84,42.33
				c13.94-10.96,21.56-22.73,25.42-36.24c16.43-57.56,32.17-115.32,48.26-172.98c2.78-9.95,5.45-19.99,9.17-29.6
				c4.94-12.76,10.78-15.42,22.65-9.33c9.31,4.78,17.54,11.65,26.25,17.6C679.39,238.2,679.39,244.88,679.39,251.55z"
              />
            </g>
          </g>
        </g>
      </svg>
    </SearchPartnerIcon>
  )
}

export function GeneanetIcon(): JSX.Element {
  return (
    <SearchPartnerIcon>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 800 800" xmlSpace="preserve">
        <style type="text/css">{`.geneanetSvg{fill:#399683;}`}</style>
        <path
          className="geneanetSvg"
          d="M697.22,396.12c-1.55,165.9-125.38,288.47-283.6,296.26c-177.53,8.73-317.11-141.14-307.66-306.51
	c-3.85-58.3,18.1-110.58,49.49-155.57c54.8-78.52,132.42-123.33,230.24-128.36C570.58,92.42,698.65,243.67,697.22,396.12z
	 M399.34,454.59c0,0-12.44,3.11-24.89-3.11c0,0,12.44,9.33,18.66,15.55C402.45,460.81,399.34,454.59,399.34,454.59z M637.43,397.52
	c0.56-51.99-15.9-99.4-47.29-141.72c-54.59-73.58-146.19-106.51-229.8-91.29c-59.07,10.75-108.16,39.6-145.14,88.1
	c-51.37,67.37-63.41,141.33-36.92,221.14c13.02,39.23,36.76,71.55,67.87,99.6c30.57,27.55,65.19,44.99,104.6,53.93
	c9.42,2.14,19.99,0.62,21.54-11.77c3.91-31.17,8.69-62.42,9.5-93.73c0.49-18.87-4.96-38.24-20.9-56.34
	c-1.18,22.14-12.95,31.61-30.48,34.87c-25.88,4.81-50.96,1.4-73.45-12.03c-29.51-17.62-34.65-40.25-16.42-69.43
	c7.33-11.74,17.18-21.9,26.93-34.09c-1.59-2.84-3.01-5.57-4.6-8.21c-9.16-15.13-12.41-29.48,3.27-43.11
	c2.47-2.15,2.31-8.42,1.88-12.63c-1.53-15.05,3.48-27.61,14.05-37.81c12.64-12.19,26.04-23.6,38.76-35.71
	c16.6-15.81,24.5-16.52,42.98-2.87c16.68,12.31,16.92,12.5,30.02-4.1c9.44-11.96,22.25-18.94,36.35-16.46
	c36.59,6.42,70.35,21.92,102.63,39.63c8.37,4.59,17.61,17.95,16.8,26.34c-1.05,10.88-11.77,20.82-19.26,32.62
	c-1.14-0.95,0.82,2.04,3.28,2.54c33.45,6.8,43.24,33.63,48.72,61.25c10.99,55.42-26.05,103.61-79.4,97.07
	c-9.53-1.17-19.03-4.61-27.92-8.46c-30.45-13.19-38.94-9.73-48,23.07c-12.4,44.91-2.52,87.99,11.22,131.39
	c6.4-0.9,11.53-1.16,16.43-2.37C561.45,600.64,636.23,509.64,637.43,397.52z M422.57,474.23c3.63-6.28,7.26-12.55,10.89-18.83
	c-1.62-0.88-3.25-1.75-4.87-2.63C418.84,456.37,413.3,461.86,422.57,474.23z"
        />
      </svg>
    </SearchPartnerIcon>
  )
}

export function GoogleIcon(): JSX.Element {
  return (
    <SearchPartnerIcon>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 800 800" xmlSpace="preserve">
        <style type="text/css">
          {`.st0{clip-path:url(#SVGID_00000119834198660365623000000017298467369212252040_);fill:#FBBC05;}
	.st1{clip-path:url(#SVGID_00000075122163452204282860000002771199501602476468_);fill:#EA4335;}
	.st2{clip-path:url(#SVGID_00000046326445347148924290000007841656747974509216_);fill:#34A853;}
	.st3{clip-path:url(#SVGID_00000044167988556644360090000016095075950529809806_);fill:#4285F4;}`}
        </style>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_1_"
                d="M658.65,354.31h-236.1v97.89h135.9c-12.67,62.19-65.65,97.89-135.9,97.89
				c-82.92,0-149.72-66.8-149.72-149.72s66.8-149.72,149.72-149.72c35.7,0,67.95,12.67,93.29,33.4l73.71-73.71
				c-44.92-39.16-102.5-63.34-167-63.34c-140.51,0-253.37,112.87-253.37,253.37s112.87,253.37,253.37,253.37
				c126.69,0,241.86-92.14,241.86-253.37C664.41,385.4,662.1,369.28,658.65,354.31z"
              />
            </defs>
            <clipPath id="SVGID_00000114794349326122570470000014896032565002155185_">
              <use xlinkHref="#SVGID_1_" style={{ overflow: 'visible' }} />
            </clipPath>
            <path
              style={{ clipPath: 'url(#SVGID_00000114794349326122570470000014896032565002155185_)', fill: '#FBBC05' }}
              d="M146.14,550.09V250.65
			l195.79,149.72L146.14,550.09z"
            />
          </g>
          <g>
            <defs>
              <path
                id="SVGID_00000164498177501805767850000009369359991769895339_"
                d="M658.65,354.31h-236.1v97.89h135.9
				c-12.67,62.19-65.65,97.89-135.9,97.89c-82.92,0-149.72-66.8-149.72-149.72s66.8-149.72,149.72-149.72
				c35.7,0,67.95,12.67,93.29,33.4l73.71-73.71c-44.92-39.16-102.5-63.34-167-63.34c-140.51,0-253.37,112.87-253.37,253.37
				s112.87,253.37,253.37,253.37c126.69,0,241.86-92.14,241.86-253.37C664.41,385.4,662.1,369.28,658.65,354.31z"
              />
            </defs>
            <clipPath id="SVGID_00000078733607339460712520000013058867394493323149_">
              <use
                xlinkHref="#SVGID_00000164498177501805767850000009369359991769895339_"
                style={{ overflow: 'visible' }}
              />
            </clipPath>
            <path
              style={{ clipPath: 'url(#SVGID_00000078733607339460712520000013058867394493323149_)', fill: '#EA4335' }}
              d="M146.14,250.65
			l195.79,149.72l80.62-70.25l276.41-44.92V123.97H146.14V250.65z"
            />
          </g>
          <g>
            <defs>
              <path
                id="SVGID_00000021104195666140800080000013019465034822642607_"
                d="M658.65,354.31h-236.1v97.89h135.9
				c-12.67,62.19-65.65,97.89-135.9,97.89c-82.92,0-149.72-66.8-149.72-149.72s66.8-149.72,149.72-149.72
				c35.7,0,67.95,12.67,93.29,33.4l73.71-73.71c-44.92-39.16-102.5-63.34-167-63.34c-140.51,0-253.37,112.87-253.37,253.37
				s112.87,253.37,253.37,253.37c126.69,0,241.86-92.14,241.86-253.37C664.41,385.4,662.1,369.28,658.65,354.31z"
              />
            </defs>
            <clipPath id="SVGID_00000083090706185014199740000000888325463084515243_">
              <use
                xlinkHref="#SVGID_00000021104195666140800080000013019465034822642607_"
                style={{ overflow: 'visible' }}
              />
            </clipPath>
            <path
              style={{ clipPath: 'url(#SVGID_00000083090706185014199740000000888325463084515243_)', fill: '#34A853' }}
              d="M146.14,550.09
			L491.65,285.2l90.98,11.52l116.32-172.75v552.82H146.14V550.09z"
            />
          </g>
          <g>
            <defs>
              <path
                id="SVGID_00000066482697619035835070000001415896347917417407_"
                d="M658.65,354.31h-236.1v97.89h135.9
				c-12.67,62.19-65.65,97.89-135.9,97.89c-82.92,0-149.72-66.8-149.72-149.72s66.8-149.72,149.72-149.72
				c35.7,0,67.95,12.67,93.29,33.4l73.71-73.71c-44.92-39.16-102.5-63.34-167-63.34c-140.51,0-253.37,112.87-253.37,253.37
				s112.87,253.37,253.37,253.37c126.69,0,241.86-92.14,241.86-253.37C664.41,385.4,662.1,369.28,658.65,354.31z"
              />
            </defs>
            <clipPath id="SVGID_00000076587552430684317740000011521600185876998290_">
              <use
                xlinkHref="#SVGID_00000066482697619035835070000001415896347917417407_"
                style={{ overflow: 'visible' }}
              />
            </clipPath>
            <path
              style={{ clipPath: 'url(#SVGID_00000076587552430684317740000011521600185876998290_)', fill: '#4285F4' }}
              d="M698.96,676.78
			L341.93,400.37l-46.07-34.55l403.09-115.17V676.78z"
            />
          </g>
        </g>
      </svg>
    </SearchPartnerIcon>
  )
}

export function MyHeritageIcon(): JSX.Element {
  return (
    <SearchPartnerIcon>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 800 800" xmlSpace="preserve">
        <style type="text/css">{`.myHeritageSvg{fill:#F56932;}`}</style>
        <g>
          <path
            className="myHeritageSvg"
            d="M430.46,175.75c110.49,6.5,198.1,105.21,198.1,218.24c0,113.01-87.61,211.71-198.1,218.2
		c160.07,14.21,259.08-98.63,259.08-218.2C689.54,274.4,590.91,161.81,430.46,175.75 M173.28,393.99
		c0-113.03,87.6-211.73,198.1-218.24C212.99,161.03,112.3,274.4,112.3,393.99c0,119.57,103.04,235.17,259.08,218.2
		C260.89,605.7,173.28,507,173.28,393.99 M611.48,393.99c-1.14-117.25-94.27-212.29-210.56-212.29
		c-116.29,0-210.55,95.04-210.55,212.29c0,102.46,72.04,187.99,167.28,207.35c31.85,6.47,36.25-75.28,27.53-129.51
		c-0.16-0.01-9.61-0.56-12.77-0.7c-6.54-0.27-12.71,7.28-16.72,8.76c-6.81,2.49-8.1-4.36-13.02-4.36c-4.31,0-10.08,6.75-25.99,3.72
		c-16.09-3.08-21.29-17.73-21.29-17.73l-4.83-2.57c-16.41-4.11-17.29-22.2-17.41-23.24c-0.93-8.82,14.39-15.53,10.08-18.28
		c-18.58-11.86-12.59-21.2-12.42-21.68c2.37-6.29,11.39-19.9,8.08-22.03c-9.11-5.84,5.85-39.89,18.99-49.34
		c1.99-10.79,13.52-28.41,24.66-32.14c-0.61-12.23,16.34-19.15,16.34-19.15c11.87-3.86,3.55-13.75,26.31-12.17
		c5.33,0.36,5.17-5.74,18.38-6.04c3.82-0.08,8.01-3.07,19.71-3.07c20.5-0.91,19.55,13.06,26.42,10.68
		c8.68-2.99,37.56,11.3,40.55,40.68c12.97-1,47.02,36.8,46.01,64.69c22.38,25.33-8.12,49.33-9.33,53.97
		c0.87,2.63,5.37,14.15,3.58,23.07c-2.1,10.44-15.24,21.85-15.78,22.24c-9.21,6.68-16.02,14.23-26.96,12.15
		c-11.31-2.13-9.16-12.64-12.52-15.18c-7.27,6.5-18.21,12.05-32.22,10.89c-1.65-0.27-7.74-0.9-8.52-0.98
		c-6.71,39.91-5.76,129.11,22.29,129.06C521.37,590.09,612.6,507.98,611.48,393.99"
          />
        </g>
      </svg>
    </SearchPartnerIcon>
  )
}

export function StoriedIcon(): JSX.Element {
  return (
    <SearchPartnerIcon>
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="-17.4 -17.2 208.8 206.4" xmlSpace="preserve">
        <style type="text/css">{`.storiedSvg{fill:#FB4142;}`}</style>
        <path
          className="storiedSvg"
          d="M94,-7 v 160 h 76 V -7 H 94 M 46,10 V 136 H 84 V 10 H 46 M 11,27 v 67 c 0,4.964264 -2.9928312,19.62471 0.03858,23.41127 C 14.365182,121.56654 29.989161,119 35,119 V 27 Z"
        />
      </svg>
    </SearchPartnerIcon>
  )
}
